import React from 'react';
import Grid, { GridItem } from 'components/Grid';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SearchWidgetLayout(_ref) {
  var widgets = _ref.widgets,
    children = _ref.children;
  if (!widgets) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsxs(Grid, {
    reverse: true,
    hasBottomSpacing: true,
    children: [/*#__PURE__*/_jsx(GridItem, {
      mSize: "1/4",
      children: widgets
    }), /*#__PURE__*/_jsx(GridItem, {
      mSize: "3/4",
      children: children
    })]
  });
}